(() => {
  if (customElements.get('ubiquiti-enquiry-modal')) return;

  class UbiquitiEnquiryModal extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.group = this.dataset.group || '';
    this.overlay = this.querySelector('[data-ubq-enquiry-overlay]');
    this.closeBtn = this.querySelector('[data-ubq-enquiry-close]');
    this.titleEl = this.querySelector('[data-ubq-enquiry-title]');
    this.typeInput = this.querySelector('[data-ubq-enquiry-type]');
    this.form = this.querySelector('.ubq-enquiry__form');
    this.success = this.querySelector('[data-ubq-enquiry-success]');
      this.submitBtn = this.form
        ? this.form.querySelector('[type="submit"]')
        : null;
      this._submitLabel = this.submitBtn ? this.submitBtn.textContent : '';

    this._onTrigger = this._onTrigger.bind(this);
    this._onOverlay = () => this.setOpen(false);
    this._onClose = () => this.setOpen(false);
    this._onKeydown = (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.setOpen(false);
    };
    this._onSubmit = this._onSubmit.bind(this);

    document.addEventListener('click', this._onTrigger);
    if (this.overlay) this.overlay.addEventListener('click', this._onOverlay);
    if (this.closeBtn) this.closeBtn.addEventListener('click', this._onClose);
    document.addEventListener('keydown', this._onKeydown);
    if (this.form) this.form.addEventListener('submit', this._onSubmit);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onTrigger);
    document.removeEventListener('keydown', this._onKeydown);
    if (this.classList.contains('is-open')) document.body.classList.remove('ubq-enquiry-open');
  }

  _onTrigger(e) {
    const btn = e.target.closest('[data-ubq-enquiry-open]');
    if (!btn) return;
    const target = btn.getAttribute('data-ubq-enquiry-target');
    if (target && target !== this.group) return;
    e.preventDefault();
    this.setOpen(true, btn.getAttribute('data-ubq-enquiry-open'));
  }

  setOpen(open, type) {
    if (open) {
      const isBulk = type === 'bulk';
      this.classList.toggle('is-bulk', isBulk);
      if (this.titleEl) {
        this.titleEl.textContent = isBulk
          ? this.titleEl.getAttribute('data-title-bulk')
          : this.titleEl.getAttribute('data-title-quote');
      }
      if (this.typeInput && this.titleEl) {
        this.typeInput.value = isBulk
          ? this.titleEl.getAttribute('data-title-bulk')
          : this.titleEl.getAttribute('data-title-quote');
      }
      if (this.form) {
        this.form.hidden = false;
        this.form.reset();
      }
      if (this.success) this.success.hidden = true;
      if (this.overlay) this.overlay.hidden = false;
      if (this.submitBtn) {
        this.submitBtn.disabled = false;
        if (this._submitLabel) this.submitBtn.textContent = this._submitLabel;
      }
    } else if (this.overlay) {
      this.overlay.hidden = true;
    }

    this.classList.toggle('is-open', open);
    document.body.classList.toggle('ubq-enquiry-open', open);
  }

  _onSubmit(e) {
    e.preventDefault();
    if (!this.form) return;

    const submitBtn = this.form.querySelector('[type="submit"]');
    const api = window.TpuStorefrontEnquiry;
    if (!api || typeof api.runEnquirySubmit !== 'function') {
      if (window.ModalToast) {
        window.ModalToast.show(
          "Thanks — we've received your enquiry and will be in touch shortly.",
        );
      }
      this.setOpen(false);
      if (this.form) this.form.reset();
      return;
    }

    const isBulk = this.classList.contains('is-bulk');
    const fv = (name) => api.fieldValue(this.form, name);
    api
      .runEnquirySubmit({
        button: submitBtn,
        successEl: this.success,
        payload: {
          enquiryType: isBulk ? 'bulk' : 'quote',
          enquiryTypeLabel: this.typeInput
            ? this.typeInput.value
            : isBulk
              ? 'Bulk'
              : 'Quote',
          name: fv('contact[Name]'),
          businessName: fv('contact[Business name]'),
          email: fv('contact[email]'),
          phone: fv('contact[Phone]'),
          product: fv('contact[Product]'),
          quantity: fv('contact[Quantity required]'),
          deliveryPostcode: fv('contact[Delivery postcode]'),
          notes: fv('contact[body]'),
        },
        onSuccess: () => {
          this.setOpen(false);
          if (this.form) {
            this.form.hidden = false;
            this.form.reset();
          }
          if (this.success) this.success.hidden = true;
        },
      })
      .catch(() => {});
  }
}

  customElements.define('ubiquiti-enquiry-modal', UbiquitiEnquiryModal);
})();
